// extracted by mini-css-extract-plugin
module.exports = {"block":"TopInterestsMock_block__FvK3j","item":"TopInterestsMock_item__EUhtc","rank":"TopInterestsMock_rank__L9tGn"};